import { useState } from "react";
import api from "../../api/Api"; 
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingBtn from "../../components/LoadingBtn/LoadingBtn";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo.png";
import "../ResetPassword/ResetPassword.css"; // reuse the same CSS

function ChangePassword() {
  const navigate = useNavigate();
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChangePassword = (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error("New password and confirm password do not match");
      return;
    }

    setLoading(true);

    api.put("/api/users/change-password", { oldPassword, newPassword })
      .then((res) => {
        if (res.data.responseCode === 200) {
          toast.success("Password changed successfully!");
          setOldPassword("");
          setNewPassword("");
          setConfirmPassword("");
          setTimeout(() => navigate("/dashboard"), 1000);
        } else {
          toast.error(res.data.message || "Failed to change password");
        }
      })
      .catch((err) => {
        const message = err?.response?.data?.message || "Failed to change password";
        toast.error(message);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      {/* <ToastContainer position="bottom-right" autoClose={3000} /> */}

      <div className="resetPasswordContainer">
        <div className="resetCard">
          <img src={logo} alt="ICS Logo" className="logo" />
          <h3 className="mb-3 mt-5">Change Password</h3>

          <form onSubmit={handleChangePassword} className="resetForm">
            <input
              type="password"
              placeholder="Old Password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
              className="passwordInput"
            />
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              className="passwordInput"
            />
            <input
              type="password"
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              className="passwordInput"
            />

            <LoadingBtn
              text={loading ? "Changing..." : "Change Password"}
              loading={loading}
              type="submit"
              disabled={loading}
              sx={{
                height: "55px",
                width: "270px",
                borderRadius: "10px",
                fontSize: "16px",
                backgroundColor: "#386ED0",
                "&:hover": { backgroundColor: "#2f5bb7" },
              }}
            />
          </form>
        </div>
      </div>
    </>
  );
}

export default ChangePassword;
